<template>
  <div style='background-color:rgba(255,255,255,0.5)'>
    <div id="login" v-if="unionid!=''">
      <h3 style="margin-bottom:20px">
        <span>绑定账号</span>
      </h3>
      <el-row class="margin-large-bottom">
        <el-input prefix-icon="el-icon-user" type="text" v-model="tel" placeholder="请输入账号或手机号码" />
      </el-row>
      <el-row class="margin-large-bottom">
        <el-input prefix-icon="el-icon-key" type="password" v-model="password" placeholder="请输入密码" @keyup.enter.native="submitForm" />
      </el-row>
      <el-row class="margin-large-bottom text-center">
        <el-button type="primary" @click="submitForm">绑定</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tel: "",
      password: "",
      unionid: "",
      openid: "",
    };
  },
  mounted() {
    // this.request();
  },
  computed: {
    beiancolor_text() {
      return "color:" + this.beiancolor;
    },
  },
  methods: {
    submitForm() {
      if (this.tel == "") {
        this.$message({
          type: "error",
          message: "请输入手机号或账号",
        });
        return;
      }
      if (this.password == "") {
        this.$message({
          type: "error",
          message: "请输入密码",
        });
        return;
      }
      this.$axios({
        method: "post",
        url: this.HOST + "/employee/login/login",
        data: {
          account: this.tel,
          password: this.password,
          unionid: this.unionid,
          openid: this.openid,
        },
      }).then((res) => {
        // console.log(res);
        if (res.data.status == 1) {
          sessionStorage.setItem("employeeuuid", res.data.employeeinfo.uuid);
          sessionStorage.setItem("employeename", res.data.employeeinfo.name);
          sessionStorage.setItem("employeetoken", res.data.token);
          sessionStorage.setItem("employeeislogin", true);
          sessionStorage.setItem(
            "sectionlist",
            JSON.stringify(res.data.sectionlist)
          );
          // if (this.terminal == "pc") {
          this.$router.push("/index");
          // } else {
          //   this.$router.push('/m'+res.data.menulist[0]['children'][0]['controller']+'/'+res.data.menulist[0]['children'][0]['action']);
          // }
        }
      });
    },
  },
  created() {
    let code = this.$route.query.code;
    if (!code) {
      let url = 'http://auth.qlsww.com/auth/get?license=oa&type=full';
				window.location.replace(url)
        return;
    }
    console.log(code);
    this.$axios({
      url: this.HOST + "/employee/login/wxlogin",
      method: "post",
      data: {
        code: code,
        terminal:'mobile'
      },
    }).then((res) => {
      if (res.data.status == 1) {
        if (res.data.unionid) {
          this.unionid = res.data.unionid;
          this.openid = res.data.openid;
        } else {
          sessionStorage.setItem("employeeuuid", res.data.employeeinfo.uuid);
          sessionStorage.setItem("employeename", res.data.employeeinfo.name);
          sessionStorage.setItem("employeetoken", res.data.token);
          sessionStorage.setItem("employeeislogin", true);
          sessionStorage.setItem(
            "sectionlist",
            JSON.stringify(res.data.sectionlist)
          );
          this.$router.push("/index");
        }
      }
    });
  },
};
</script>

<style>
.puzzle-box {
  box-sizing: border-box;
}

.puzzle-container {
  box-sizing: border-box;
  width: 100%;
  display: inline-block !important;
}

.title {
  padding-top: 50px;
  margin-bottom: 20px;
}
</style>
